import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  groupList:[],
  loading:true,
  error:null,
  errorMsg:null,
  current_page:0,
  totalPages:0,
  update_group_user_loading:false,
  No_Group_Created:null,
  Open_create_new_bot:null
};

const groupSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
 
    fetchGroupListSuccess(state, action) {
      const { current_page ,data,total_pages } = action.payload
 
      
      state.groupList = data
      state.loading = false;
      state.errorMsg = false;
      state.current_page =current_page
      state.totalPages=total_pages
      if(data.length === 0 && state.No_Group_Created === null ){
          state.No_Group_Created = true;
      }
    },
    start_update_group_user_loading(state, action) {
        state.update_group_user_loading=true
    },
    fetchGroupListFailed(state, action) {

      state.loading = false;
      state.errorMsg = action.payload;
      

    },
    reset_group_flag(state) {
      state.error = null;
      state.loading = false;
      state.errorMsg = false;
      state.groupList = []
      state.current_page = 0
    },

    start_group_fetch_loading(state, action) {
      state.loading = true;
    },
    create_new_group_success(state,action){
      state.loading=false
    },
    update_group_user_sucess(state, action) {
      state.update_group_user_loading=false
    }
    ,
    update_group_user_fail(state, action) {
      state.update_group_user_loading=false
    },
    leave_group_sucess(state,action){
      state.loading
    },
    leave_group_fail(state,action){
      state.loading=false;
      state.error=true
      state.errorMsg=action.payload
    },
    set_no_group_Created(state, action){
      state.No_Group_Created = action.payload
    },
    set_open_create_new_bot(state,action){
      if(state.Open_create_new_bot === null)
      {

        state.Open_create_new_bot = action.payload
      }else{
        state.Open_create_new_bot = false
      }
    }, 
    delete_group_fail(state,action){
      state.loading=false
      state.error=true
      state.errorMsg=action.payload
    },


  },
});

export const {
  fetchGroupListSuccess,
  fetchGroupListFailed,
  reset_group_flag,
  start_group_fetch_loading,
  create_new_group_success,
  start_update_group_user_loading,
  update_group_user_sucess,
  update_group_user_fail,
  set_no_group_Created,
  set_open_create_new_bot,
  delete_group_fail
} = groupSlice.actions

export default groupSlice.reducer;